import { SunWirelessIcon } from './SunWirelessIcon';

/**
 * author: Michael Irigoyen
 * id 1A5DE4DC-5B3B-4378-ADB2-5D51AA64896D
 * name sun-wireless
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/sun-wireless.svg
 * tags
 * - Home Automation 
 * - Weather 
 */
export const UvRayIcon = SunWirelessIcon;
export default UvRayIcon